import React, { useState, useEffect } from 'react';
import {
  createNewCohort,
  getAllCohorts,
  getUserById,
  updateCohort,
} from '../../../services/apiService';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import TextField from '@material-ui/core/TextField';

import Button from '@material-ui/core/Button';
import LoadingCircleIcon from '../../../icons/LoadingCircle';
import moment from 'moment';
import CohortTable from './utils/cohortTable';
import CoachSelection from './components/CoachSelection';
import { COURSE_TYPE } from '../../../constants';
import BulkAdd from './components/BulkAdd';
import { HiOutlinePlus } from 'react-icons/hi';

function CohortDashboard() {
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [careerCoach, setcareerCoach] = useState(null);
  const [champion, setChampion] = useState(null);
  const [communicationCoach, setCommunicationCoach] = useState(null);
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  console.log(loading, 'loading');

  const [buttonDisabled, setButtonDisabled] = useState(false);

  const initialFormData = {
    name: '',
    startDate: '',
    careerCoach: '',
    champion: '',
    courseType: COURSE_TYPE.DATA_SCIENCE,
  };
  const [formData, setFormData] = useState(Object.freeze(initialFormData));

  const populateCareerCoachAndChampion = async (cohort) => {
    const { careerCoach, champion, communicationCoach } = cohort;

    const tempObj = {};
    if (careerCoach) {
      const Coach = await getUserById(careerCoach);
      tempObj.careerCoach = Coach;
    }

    if (champion) {
      if (champion === careerCoach) {
        tempObj.champion = tempObj.careerCoach;
      } else {
        const Champion = await getUserById(champion);
        tempObj.champion = Champion;
      }
    }

    if (communicationCoach) {
      if (communicationCoach === careerCoach) {
        tempObj.communicationCoach = tempObj.careerCoach;
      } else if (communicationCoach === champion) {
        tempObj.communicationCoach = tempObj.champion;
      } else {
        const CommunicationCoach = await getUserById(communicationCoach);
        tempObj.communicationCoach = CommunicationCoach;
      }
    }

    return {
      ...cohort,
      ...tempObj,
    };
  };

  const getCareerCoachAndChampionDetails = async (cohorts) => {
    return Promise.all(
      cohorts.map((cohort) => populateCareerCoachAndChampion(cohort))
    );
  };

  const fetchCohorts = async () => {
    const cohorts = await getAllCohorts();
    const updatedCohorts = await getCareerCoachAndChampionDetails(cohorts);
    setData(updatedCohorts);
  };

  useEffect(() => {
    fetchCohorts();
  }, []);

  const editHandler = (row) => {
    setChampion(row?.champion);
    setcareerCoach(row?.careerCoach);
    setCommunicationCoach(row?.communicationCoach);

    setFormData({
      name: row.name,
      startDate: moment(row.startDate).format('YYYY-MM-DD'),
      careerCoach: row.careerCoach,
      champion: row.champion,
      communicationCoach: row.communicationCoach,
      courseType: row.courseType,
    });
    setDisabled(true);
    toggleDialog();
  };

  const toggleDialog = () => {
    setOpen((prevState) => !prevState);
    setButtonDisabled(false);
    if (open) setFormData(initialFormData);
    if (disabled) setDisabled(false);
  };

  const handleCreateCohort = async () => {
    if (!formData.name || !formData.courseType) return;
    setButtonDisabled(true);
    setLoading(true);
    const editData = {
      ...formData,
      champion: champion?.id,
      careerCoach: careerCoach?.id,
      communicationCoach: communicationCoach?.id,
    };
    try {
      await createNewCohort(editData);
    } catch (e) {
    } finally {
      setLoading(false);
    }
    setcareerCoach(null);
    setChampion(null);
    setCommunicationCoach(null);
    toggleDialog();
    fetchCohorts();
  };

  const handleEditCohort = async () => {
    if (!formData.name || !formData.courseType) return;
    setButtonDisabled(true);
    setLoading(true);
    const editData = {
      ...formData,
      champion: champion?.id,
      careerCoach: careerCoach?.id,
      communicationCoach: communicationCoach?.id,
      id: data.find((item) => item.name === formData.name)?.id,
    };
    await updateCohort(editData);
    setLoading(false);
    setcareerCoach(null);
    setChampion(null);
    setCommunicationCoach(null);
    toggleDialog();
    fetchCohorts();
  };

  const handleChange = (e) => {
    const { target } = e;
    setFormData({ ...formData, [target.name]: target.value });
  };

  const handleSubmit = (e, type) => {
    e.preventDefault();
    type === 'edit' ? handleEditCohort() : handleCreateCohort();
  };

  return (
    <div>
      {/* Page header */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 24,
        }}
      >
        <div>
          <h1
            style={{
              fontSize: 22,
              fontWeight: 700,
              color: '#111827',
              margin: 0,
            }}
          >
            Cohort Dashboard
          </h1>
          <p style={{ fontSize: 13, color: '#6B7280', marginTop: 4, marginBottom: 0 }}>
            Manage all cohorts
          </p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button
            onClick={() => setAddDialogOpen(true)}
            style={{
              fontSize: 13,
              fontWeight: 600,
              color: '#374151',
              backgroundColor: '#fff',
              border: '1px solid #E5E7EB',
              borderRadius: 4,
              padding: '8px 16px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
            }}
          >
            Bulk Add Users
          </button>
          <button
            onClick={toggleDialog}
            style={{
              fontSize: 13,
              fontWeight: 600,
              color: '#fff',
              backgroundColor: '#4F46E5',
              border: 'none',
              borderRadius: 4,
              padding: '8px 16px',
              cursor: 'pointer',
              boxShadow: '0 2px 8px rgba(79,70,229,0.25)',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
            }}
          >
            <HiOutlinePlus size={14} /> Create Cohort
          </button>
        </div>
      </div>
      {data.length === 0 ? (
        <div className='m-auto w-full mt-20 text-center'>
          <LoadingCircleIcon iconStyle='w-10 h-10 mr-2' />
          <h1>Loading</h1>
        </div>
      ) : (
        <>
          <CohortTable rowData={data} editHandler={editHandler} />
          {/* <SmartTable
            rows={data}
            columnHeads={columsHeads}
            actionGroup={(row) => (
              <div>
                <IconButton onClick={() => editHandler(row)}>
                  <EditIcon />
                </IconButton>
              </div>
            )}
          /> */}
        </>
      )}

      {/* --- Form Dialog --- */}
      <Dialog
        aria-labelledby='simple-dialog-title'
        open={open}
        onClose={toggleDialog}
      >
        <DialogTitle id='simple-dialog-title'>
          {disabled ? 'Update Cohort' : 'Create New Cohort'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {disabled
              ? 'Update details'
              : 'Enter details to create a new cohort.'}
          </DialogContentText>
          <form
            onSubmit={(e) => handleSubmit(e, disabled ? 'edit' : 'create')}
            className='flex flex-col w-96'
          >
            <TextField
              className='border border-solid mb-3 outline-none p-1 rounded'
              id='name'
              name='name'
              label='Name'
              required
              value={formData.name}
              onChange={handleChange}
              disabled={disabled}
              margin='normal'
              variant='outlined'
            />
            <label htmlFor='courseType' className='mt-3 mb-1 text-xs'>
              Course Type
            </label>
            <Select
              disabled={disabled}
              name='courseType'
              id='courseType'
              value={formData.courseType}
              onChange={handleChange}
            >
              <MenuItem value={COURSE_TYPE.DATA_SCIENCE}>Data Science</MenuItem>
              <MenuItem value={COURSE_TYPE.WEB3}>Web3</MenuItem>
            </Select>
            <label htmlFor='startDate' className='mt-3 mb-1 text-xs'>
              Start Date
            </label>
            <input
              className='border border-solid mb-3 outline-none p-3 rounded'
              id='startDate'
              name='startDate'
              required
              value={formData.startDate}
              onChange={handleChange}
              type='date'
            />
            <div className='mb-3'>
              <CoachSelection
                coach={careerCoach}
                setCoach={setcareerCoach}
                label='Career Coach'
              />
            </div>

            <CoachSelection
              coach={champion}
              setCoach={setChampion}
              label='Champion'
              courseType={formData?.courseType}
            />

            <CoachSelection
              coach={communicationCoach}
              setCoach={setCommunicationCoach}
              label='Communication Coach'
              courseType={formData?.courseType}
            />
            <DialogActions>
              <Button onClick={toggleDialog} color='primary'>
                Cancel
              </Button>
              {loading ? (
                <LoadingCircleIcon iconStyle='w-4 h-4 mr-2' />
              ) : (
                <Button color='primary' type='submit' disabled={buttonDisabled}>
                  {disabled ? 'Edit' : 'Create'}
                </Button>
              )}
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
      <BulkAdd
        dialogOpen={addDialogOpen}
        setDialogOpen={setAddDialogOpen}
        // dataFetch={dataFetch}
      />
    </div>
  );
}

export default CohortDashboard;
